import {
  RECALCULATE_TASK_CREATE_REQUEST,
  RECALCULATE_TASK_CREATE_SUCCESS,
  RECALCULATE_TASK_CREATE_FAILURE,
} from './types/RecalculateTasksCreateActionsTypes';

export function postRecalculateTaskCreateRequestActionCreator(context,
                                                              newCalculateFromDate,
                                                              newImpcCode) {
  return {
    type: RECALCULATE_TASK_CREATE_REQUEST,
    payload: {
      appContext: context,
      params: {
        calculateFromDate: newCalculateFromDate,
        impcCode: newImpcCode,
      },
    },
  };
}

export function postRecalculateTaskCreateSuccessActionCreator(data) {
  return {
    type: RECALCULATE_TASK_CREATE_SUCCESS,
    payload: data,
  };
}

export function postRecalculateTaskCreateFailureActionCreator(error) {
  return {
    type: RECALCULATE_TASK_CREATE_FAILURE,
    payload: error,
    error: true,
  };
}
